import type { JobModuleIconProps } from "./job-module-icon.type";

import {
  FileOutlined,
  ExperimentOutlined,
  WarningOutlined,
  HeartOutlined,
} from "@ant-design/icons";

import "./job-module-icon.style.less";

const JobModuleIcon = ({ iconName }: JobModuleIconProps) => {
  let icon = undefined;
  switch (iconName) {
    case "experiment":
      icon = <ExperimentOutlined />;
      break;
    case "warning":
      icon = <WarningOutlined />;
      break;
    case "heart":
      icon = <HeartOutlined />;
      break;
    default:
      icon = <FileOutlined />;
      break;
  }

  return <span className="job-module-icon">{icon}</span>;
};

export default JobModuleIcon;
